"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Translate = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Translate_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4.829l.38 1.615a.5.5 0 0 0 .487.385H14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9.171L8.791.385A.5.5 0 0 0 8.304 0H2Zm8.585 8h2.977c.242 0 .438-.224.438-.5s-.196-.5-.438-.5H10.35l.235 1Zm.707 3h2.27c.242 0 .438-.224.438-.5s-.196-.5-.438-.5h-2.505l.236 1ZM4.5 9.5c-.013.499-.456.954-1.068 1.06-.683.12-1.318-.24-1.419-.803-.1-.562.372-1.115 1.055-1.234.148-.026.294-.03.432-.013V5a.5.5 0 0 1 .41-.492l3.5-.5A.5.5 0 0 1 8 4.5v4c-.013.498-.456.954-1.068 1.06-.683.12-1.318-.24-1.419-.803-.1-.562.372-1.115 1.055-1.234.148-.026.294-.03.432-.013V5.552l-2.5.38V9.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Translate_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Translate;
exports["default"] = _default;